import styled from 'styled-components';

export const Style = styled.div`
  display: flex;
  flex: 1;
  gap: 5%;

  .cont {
    flex: 1;
    display: flex;
    flex-direction: column;

    .p-cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      margin-top: 40px;
    }

    p {
      color: #000000;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      margin-bottom: 0;
    }

    .h4-cont {
      height: 35.2px; 
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .h4 {
      margin: 0;
      font-size: var(--font-size-lg);
      font-weight: 600;
      color: #101828;
      text-align: center;
    }
  }

  .chart-cont {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    position: relative;

    .chart-inner {
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h4 {
        color: #101828;
        font-size: var(--size-lg);
        font-weight: 500;
        margin-bottom: 0px;
      }
    }
  }
`;
